import type { AdminData } from '../../api/user-client/user-client.type';

enum Roles {
  ADMIN = 'admin',
  USER = 'user',
}

type RolesData = {
  role: Roles;
  isAdmin: boolean;
  admins: AdminData[];
};

enum Permissions {
  FinancialsRead = 'financials_read',
  FinancialsWrite = 'financials_write',
}

export { Permissions, Roles };
export type { RolesData };
